<template>
  <div class="container">
    <div class="home-banner">
      <img class="banner-bg" src="@/assets/dashuju.png" alt="">
      <div class="textBox typeArea">
        <p class="centerBanner animated zoomIn">政府大数据</p>
        <p class="title_secound animated centerBanner  zoomIn" style="font-size: 24px;">基于分析、评价、预测、预警、建议等决策抓手，为政府、行业、企业和民生提供精准决策</p>
      </div>
    </div>
    <div class="zhengfu">
      <div class="zf-box">
        <div class="zf-cont">
          <div style="padding-bottom: 80px;"></div>
          <div class="common-title">
            概述 
          </div>
          <div class="zf-text">
            <p>目前各地普遍成立了大数据局，汇集了政府部门掌握的数据，包括但不限于工商、司法、公共信用记录、社保、水电煤气的耗用等等；税局系统的数据自成一体，主要包括了纳税申报、企业财务报表、发票及社保数据。 </p>
            <p>对于大数据局聚合的数据，以及建立在金税三期基础上的标准化税局数据，当前的应用焦点包括了涉税风控、税收经济分析、普惠金融、政府的产业和企业扶植等领域。 </p>
          </div>
        </div>
      </div>
      <div class="hy">
        <div class="hy-box">
          <div class="hy-cont">
            <div style="padding-bottom: 80px;"></div>
            <div class="common-title">
              应用场景 
            </div>
            <div class="hy-list">
              <ul>
                  <li>
                    <a @click="goView('shuiju')">
                    <div class="hy-list-img">
                      <img src="@/assets/s-1.png" alt="">
                    </div>
                    <div class="hy-list-text">
                      税局的数字化涉税风险管理
                    </div>
                    <div class="hy-list-info animatedpull pullBox">
                      <div class="hy-info-title">
                        税局的数字化涉税风险管理
                      </div>
                      <div class="hy-info-text">
                        大数据风险管理局在全国税局系统的设立，一个重要责任是提升税局大数据在涉税风险识别中的作用，改变经验识别覆盖面小、准确性差的状况。
                      </div>
                    </div>
                    </a>
                  </li>
                  <li>
                    <a @click="goView('quyu')">
                    <div class="hy-list-img">
                      <img src="@/assets/s-2.png" alt="">
                    </div>
                    <div class="hy-list-text">
                      区域经济分析与企业画像分析
                    </div>
                    <div class="hy-list-info animatedpull pullBox">
                      <div class="hy-info-title">
                        区域经济分析与企业画像分析
                      </div>
                      <div class="hy-info-text">
                        税收经济分析处在全国税局系统的设立，一个重要的责任是使用税局大数据对当地经济的总体发展态势、对产业和企业的成长与产值和税收贡献进行分析与跟踪，从而为政府部门的区域经济规划、为产业发展和企业扶植政策的制定提供数字化依据。
                      </div>
                    </div>
                    </a>
                  </li>
                  <li>
                    <a @click="goView('jinrong')">
                    <div class="hy-list-img">
                      <img src="@/assets/s-3.png" alt="">
                    </div>
                    <div class="hy-list-text">
                      对中小微企业的扶植性贷款(普惠金融)
                    </div>
                    <div class="hy-list-info animatedpull pullBox">
                      <div class="hy-info-title">
                        对中小微企业的扶植性贷款(普惠金融)
                      </div>
                      <div class="hy-info-text">
                        如何向缺乏信用历史的中小微企业提供扶植性的贷款是一个风控难题，一个重要的解决方案是使用政府大数据为授信和贷后管理提供数字化辅助决策手段。
                      </div>
                    </div>
                    </a>
                  </li>
                <div style="clear: both;"></div>
              </ul>
            </div>
            <div style="padding-bottom: 80px;"></div>
          </div>
        </div>
      </div>
  </div>
</div>

</template>

<script>
export default {
  name: "government",
  data() {
    return {
    };
  },
  methods: {
    goView(name) {
      this.$router.push({name: name})
    },
  },
  mounted() {
    $('.hy-list ul li').mouseenter( function(){
      $(this).find('.hy-list-info').css("display","block");
      $(this).find('.hy-list-info').addClass("animatedpull");
      $(this).find('.hy-list-info').addClass("pullBox");
    }).mouseleave( function(){
      $(this).find('.hy-list-info').css("display","none");
      $(this).find('.hy-list-info').removeClass("animatedpull");
      $(this).find('.hy-list-info').removeClass("pullBox");
    });
  },
}
</script>

<style scoped>
   
</style>